import { getPartnerIdFromUrl } from "@utils/helpers/getPartnerIdFromUrl";
import { PartnerId } from "@utils/types";

export const hasPartnerId = () => getPartnerIdFromUrl() !== PartnerId.None;
